import {Injectable} from '@angular/core';
import {HttpClient, HttpRequest, HttpParams, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import * as _ from 'lodash';

import {environment} from '#env';
import {IResponse,Response, Supplier, Customer, PromoCode, FoodItem, Inquiries, Quotation, ProposedMenu, Role, User, PaginationData, Categories, HelpCenter} from '#defs';
import {SwPush} from '@angular/service-worker';

const API = (affix) => environment.apiUrl + '/' + affix;

@Injectable({
  providedIn: 'root'
})
export class RequestsService {
  apiUrl: string = environment.apiUrl;
  constructor(private http: HttpClient,
              private swPush: SwPush) {
  }
  getItemsForSupplier(supplierId, keyword = null, page=1, limit=999,isPromoPage=false): Observable<any> {
    let params = new HttpParams().set('supplierId', supplierId).set('page', String(page)).set('limit', String(limit));
    if(keyword){
      params = params.set('keyword', keyword)
    }
    if(isPromoPage){
      params = params.set('isPromoPage','true');
    }
    return this.http.get(this.apiUrl + '/supplier/' + supplierId + '/food-item', { params: params });
  }
  getItemsForChain(chainId, keyword = null, page = 1, limit = 999, isPromoPage = false): Observable<any> {
    let params = new HttpParams().set('chainId', chainId).set('page', String(page)).set('limit', String(limit));
    if (keyword) {
      params = params.set('keyword', keyword)
    }
    if(isPromoPage){
      params = params.set('isPromoPage','true');
    }
    return this.http.get(this.apiUrl + '/chain/' + chainId + '/food-item', {params: params});
  }

  downloadImageAssets(id){
    let params = new HttpParams().set('downloadAssets', 'true');
    return this.http.get(API('promo/' + id), {params});
  }

  /**
   * [R] Get restaurant Items
   * @returns {Promise<Array<any>>}
   */
  public restaurantItems(branch: string = null): Promise<any> {
    let params = new HttpParams();
    if (branch) {
      params = params.set('supplierId', branch);
    }
    return this.http.get(API('restaurant/items'), {params}).toPromise();
  }

   /**
   * [R] Get restaurant Items
   * @returns {Promise<Array<any>>}
   */
  public getNoOfAvailableItems(branch: string = null): Promise<any> {
    let params = new HttpParams();
    if (branch) {
      params = params.set('supplierId', branch);
    }
    return this.http.get(API('restaurant/items/public'), {params}).toPromise();
  }


 /**
 * [R] Get restaurant Items, paginated
 * @returns {Promis<Array<any>>}
 */
  public restaurantPagedItems(branch: string = null, paginationData: PaginationData): Promise<any> {
    let params = new HttpParams();
    if (branch) {
      params = params.set('supplierId', branch);
    }

    params = params.set('offset',paginationData.offset.toString());
    params = params.set('limit', paginationData.limit.toString());
    params = params.set('searchText', paginationData.searchText);

    return this.http.get(API('restaurant/items/paged'), {params}).toPromise();
  }

  /**
   *
   * @param branch
   *
   * @param paginationData
   */
  public restaurantPagedDraftItems(branch: string = null, paginationData: PaginationData): Promise<any> {
    let params = new HttpParams();
    if (branch) {
      params = params.set('supplierId', branch);
    }

    params = params.set('offset',paginationData.offset.toString());
    params = params.set('limit', paginationData.limit.toString());

    return this.http.get(API('restaurant/items/drafts/paged'), {params}).toPromise();
  }

  /**
   * [R] Get restaurant Items
   * @returns {Promise<Array<any>>}
   */
  public restaurantCustomItems(branch: string = null): Promise<any> {
    let params = new HttpParams();
    if (branch) {
      params = params.set('supplierId', branch);
    }
    return this.http.get(API('restaurant/customItems'), {params}).toPromise();
  }

  public restaurantPaginatedCustomItems(branch: string = null, paginationData: PaginationData): Promise<any> {
    let params = new HttpParams();
    if (branch) {
      params = params.set('supplierId', branch)
    }
    params = params.set('offset', paginationData.offset.toString());
    params = params.set('limit', paginationData.limit.toString());
    params = params.set('searchText', paginationData.searchText);

    return this.http.get(API('restaurant/customItems/paged'), {params}).toPromise();
  }

  public restaurantPaginatedDraftCustomItems(branch: string = null, paginationData: PaginationData): Promise<any> {
    let params = new HttpParams();
    if (branch) {
      params = params.set('supplierId', branch)
    }
    params = params.set('offset', paginationData.offset.toString());
    params = params.set('limit', paginationData.limit.toString());

    return this.http.get(API('restaurant/customItems/drafts/paged'), {params}).toPromise();
  }

  public restaurantPaginatedMenuSections(branch: string = null, supplierId: string, paginationData: PaginationData): Promise<any> {
    let params = new HttpParams();
    if (branch) {
      params = params.set('id', branch)
    }
    params = params.set('offset', paginationData.offset.toString());
    params = params.set('limit', paginationData.limit.toString());

    return this.http.get(API(`restaurant/menu-sections/paged/${supplierId}`), {params}).toPromise();
  }

  deleteSupplierDraft(supplierDraftId: string): Observable<any> {
    const params = new HttpParams().set('deleted', 'true');
    return this.http.delete(API('supplier/drafts/' + supplierDraftId), {params});
  }

  deleteFoodItemDraft(foodItemDraftId: string): Observable<any> {
    const params = new HttpParams().set('deleted', 'true');
    return this.http.delete(API('food-item-draft/' + foodItemDraftId), {params});
  }

  deleteFoodCustomItemDraft(foodCustomItemDraftId: string): Observable<any> {
    const params = new HttpParams().set('deleted', 'true');
    return this.http.delete(API('food-custom-item-draft/' + foodCustomItemDraftId), {params});
  }

  /**
   * Create new Order
   * @returns {Observable<any>}
   * @param item
   */
  createNewOrder(item): Observable<any> {
    return this.http.post(API('order/new'), item);
  }

  /**
   * Get order details
   * @returns {Observable<any>}
   * @param orderId
   * @param supplierId
   */
  getOrderDetails(orderId: string, supplierId?: string): Observable<any> {
    let params = new HttpParams();
    if (supplierId) {
      params = params.set('supplierId', supplierId);
    }
    return this.http.get(API('order/' + orderId), {params});
  }

  /**
   * Get order details
   * @returns {Observable<any>}
   * @param orderId
   */
  getDriversLocation(orderId: string): Observable<any> {
    return this.http.get(API('restaurant/' + orderId + '/driver-location'));
  }

  generatePurchaseOrder(orderId: string, supplierId: string): Observable<any> {
    const params = new HttpParams().set('supplierId', supplierId);
    const req = new HttpRequest('GET', API('order/purchase-order/' + orderId), {
      reportProgress: true,
      params
    });

    return this.http.request(req);
  }

  generateDo(orderId: string, supplierId: string): Observable<any> {
    const params = new HttpParams().set('supplierId', supplierId);
    const req = new HttpRequest('GET', API('order/delivery-order/' + orderId), {
      reportProgress: true,
      params
    });

    return this.http.request(req);
  }

  /**
   *
   * @param input
   * @param sessionToken
   */
  getBuildingAndAddress(input: string, sessionToken?: string): Observable<any> {
    let params = new HttpParams().set('input', input);
    if (sessionToken) {
      params = params.set('sessionToken', sessionToken);
    }
    return this.http.get(API('restaurant/building'), {params});
  }

  /**
   *
   * @param supplierId
   */
  getFoodItems(supplierId): Observable<any> {
    const params = new HttpParams().set('supplierId', supplierId);
    return this.http.get(API('supplier/menu-food-item'), {params});
  }

  /**
   *
   * @param supplierId
   * @param category
   */
  getCustomItemsForSupplier(supplierId, category?: string): Observable<any> {
    const params = new HttpParams().set('supplierId', supplierId);
    const categoryUrl = category ? '/' + category : '';
    if (category) {
      params.set('category', category);
    }
    return this.http.get(API('supplier/' + supplierId + '/food-custom-item' + categoryUrl), {params: params});
  }

  /**
   * Vendor wallet — balance, top-up history and ledger.
   *
   * The supplier is taken from the auth token server-side, so nothing is
   * passed here; a chain can scope to a branch with `supplierId`.
   */
  getVendorWallet(supplierId: string = null): Observable<any> {
    let params = new HttpParams();
    if (supplierId) {
      params = params.set('supplierId', supplierId);
    }
    return this.http.get(API('vendor/topup'), {params});
  }

  /** Request a wallet top-up. Lands as `pending` until finance approves it. */
  requestVendorTopup(data): Observable<any> {
    return this.http.post(API('vendor/topup'), data);
  }

  /**
   * Get all customers for suppliers
   * @returns {Observable<any>}
   * @param type all/inactive customer
   * @param query name, email and mobileNumber
   * @param offset
   * @param limit
   */
  getCustomersForSupplier(type: string, query: string, offset: string, limit: string, branch: string = null,lead='false'): Observable<any> {
    let params = new HttpParams();

    params = params.set('filter', query);
    params = params.set('lead', lead);
    params = params.set('offset', offset);
    params = params.set('limit', limit);
    params = params.set('type', type);
    if (branch) {
      params = params.set('supplierId', branch);
    }
    return this.http.get(API('vendor/customers'), {params});
  }

  /**
   * Get all customers for suppliers
   * @returns {Observable<any>}
   * @param id
   * @param offset
   * @param limit
   */
  getCustomerForSupplierById(id: string, offset: string, limit: string): Observable<any> {
    let params = new HttpParams();
    params = params.append('offset', offset);
    params = params.append('limit', limit);
    return this.http.get(API('vendor/customer/' + id), {params});
  }

  /**
   *
   * @param id
   */
  getItem(id: string): Observable<any> {
    const urlParams = '/' + id;
    return this.http.get(API('food-item' + urlParams));
  }

  viewSearchResults(search_term: string) {
    window['dataLayer'] = window['dataLayer'] || [];
    window['dataLayer'].push({
      'event': 'view_search_results',
      'search_term': search_term
    });
  }

  search(search_term: string) {
    window['dataLayer'] = window['dataLayer'] || [];
    window['dataLayer'].push({
      'event': 'search',
      'search_term': search_term
    });
  }

  /**
   * Ask for saved building to the server.
   * @param {string} query
   * @param {boolean} google
   * @returns {Promise<Building[]>}
   */
  searchBuilding(query: string, google = false): Observable<any> {
    // set up url params
    let params = new HttpParams();
    params = params.set('searchString', query);
    params = params.set('google', google.toString());

    return this.http.get(API('buildings'), {params});
  }

  /**
   * Search and auto complete building
   * @param q
   * @param sessionToken
   */
  searchAutocompleteActiveBuldings(q: string, sessionToken?: string): Observable<any> {
    let params = new HttpParams().set('input', q);
    if (sessionToken) {
      params = params.set('sessionToken', sessionToken);
    }
    return this.http.get(API('/building/find/'), {params: params});
  }

  /**
   * [R] Set food items status
   * @param {object} data
   * @returns {Observable<Array<any>>}
   */
  public setFoodItemStatus(data: object): Observable<void> {
    return this.http.post(API('restaurant/change-food-item-status'), data).pipe(
      map((res: IResponse<any>) => {
        if (res.error) {
          throw res.error;
        }
      })
    );
  }

  /**
   * [R] Get orders report
   * @param {string} date
   * @param toDate
   * @param paging
   * @param limit
   * @param filters
   * @returns {Observable<Array<any>>}
   */
  public ordersReport(date?: string, toDate?: string, paging?: number, limit?: number, filters?: object,isSmartCanteenUpcoming=false): Observable<Array<any>> {
    let params = new HttpParams();
    if (paging) {
      params = params.append('offset', paging.toString(10));
    }
    if (limit) {
      params = params.append('limit', limit.toString(10));
    }

    _.forEach(filters, (v, k) => {
      if (v) {
        params = params.append(k.toString(), v);
      }
    });
    if(isSmartCanteenUpcoming){
      params = params.append('page', 'upcoming-orders');
      return this.http.get(API('restaurant/reports' + (date ? `/${date}` : '') + (toDate ? `/${toDate}` : '')+'/upcoming'), {params}).pipe(
        map((res: IResponse<any>) => {
          if (res.data) {
            return res.data.items;
          }
        })
      );
    }
    return this.http.get(API('restaurant/reports' + (date ? `/${date}` : '') + (toDate ? `/${toDate}` : '')), {params}).pipe(
      map((res: IResponse<any>) => {
        if (res.data) {
          return res.data.items;
        }
      })
    );
  }

  /**
   * [R] Get orders report
   * @param {string} date
   * @param toDate
   * @param offset
   * @param limit
   * @param filters
   * @returns {Observable<Array<any>>}
   */
  public ordersMonthlyReport(date?: string, toDate?: string, offset?: number, limit?: number, filters?: object): Observable<any> {
    let params = new HttpParams();
   
    if (offset !== undefined && offset !== null) {
      params = params.set('offset', offset.toString());
    }
    if (limit !== undefined && limit !== null) {
      params = params.set('limit', limit.toString());
    }
    _.forEach(filters, (v, k) => {
      if (v) {
        params = params.append(k.toString(), v);
      }
    });
    
    return this.http.get(API('restaurant/reports' + (date ? `/${date}` : '') + (toDate ? `/${toDate}` : '')+'/monthly'), {params});
  }

  getCategories(): Promise<Categories[]> {
    return new Promise(resolve => {
      this.http.get(this.apiUrl + '/helpcentercategories')
        .subscribe(
          (response: Response) => {
            if (!response.success) {
              resolve([]);
              return alert('Failed to retrieve categories');
            }

            resolve(response.data.items as Categories[]);
          },
          error => {
            resolve([]);
            console.error(error);
            alert('An error occurred, please check the logs');
          });
    });
  }
  getHelpCenter(id): Promise<HelpCenter| null> {
    return new Promise(resolve => {
      this.http.get(this.apiUrl + '/helpCenter/' + id+'/slug')
        .subscribe(
          (response: Response) => {
            if (!response.success) {
              resolve(null);
              return alert('Failed to retrieve HelpCenter');
            }

            resolve(response.data.item as HelpCenter);
          },
          error => {
            resolve(null);
            console.error(error);
            alert('An error occurred, please check the logs');
          });
    });
  }


  /**
   * [R] Get upcoming orders
   * @param {string} date
   * @param toDate
   * @param paging
   * @param limit
   * @param filters
   * @returns {Observable<Array<any>>}
   */
  public upcomingOrdersReport(date?: string, toDate?: string, paging?: number, limit?: number, filters?: object): Observable<Array<any>> {
    let params = new HttpParams();
    if (paging) {
      params = params.append('offset', paging.toString(10));
    }
    if (limit) {
      params = params.append('limit', limit.toString(10));
    }

    _.forEach(filters, (v, k) => {
      if (v) {
        params = params.append(k.toString(), v);
      }
    });
    return this.http.get(API('restaurant/upcoming-orders' + (date ? `/${date}` : '') + (toDate ? `/${toDate}` : '')), {params}).pipe(
      map((res: IResponse<any>) => {
        if (res.data) {
          return res.data.items;
        }
      })
    );
  }

  /**
   *
   * @param supplierId
   * @param fromDate
   * @param toDate
   * @param groupBy
   */
  getOrdersByMonth(supplierId: string, fromDate: any, toDate: any, groupBy: string): Observable<any> {
    let params = new HttpParams();
    params = params.set('fromDate', fromDate);
    params = params.set('toDate', toDate);
    params = params.set('groupBy', groupBy);
    return this.http.get(API(`restaurant/${supplierId}/chart/orders-by-month`), {params});
  }

  getListOfReviews(supplierId: string, offset: number, limit: number, branch: string = null,reviewsFilter:string=null): Observable<any> {
    let params = new HttpParams();
    params = params.set('offset', offset.toString());
    params = params.set('limit', limit.toString());
    if (branch) {
      params = params.set('supplierId', branch);
    }
    if (reviewsFilter) {
      params = params.set('reviewsFilter', reviewsFilter);
    }

    return this.http.get(API(`restaurant/${supplierId}/reviews`), {params});
  }

  /**
   * [R] Set food items as ready
   * @param {object} data
   * @returns {Observable<Array<any>>}
   */
  public setAsReady(data: object): void {
    this.http.post(API('restaurant/set-ready'), data).subscribe();
  }

  /**
   * [R] Delete item promotion
   * @returns {Observable<Array<any>>}
   * @param itemId
   */
  public deletePromotion(itemId: string): Observable<void> {
    return this.http.delete(API('restaurant/promotion-items/' + itemId)).pipe(
      map((res: IResponse<any>) => {
        if (res.error) {
          throw res.error;
        }
      })
    );
  }

  /**
   * [R] Set item promotion
   * @param {object} data
   * @returns {Observable<Array<any>>}
   */
  public setPromotion(data: object): Observable<void> {
    return this.http.post(API('restaurant/set-promotion'), data).pipe(
      map((res: IResponse<any>) => {
        if (res.error) {
          throw res.error;
        }
      })
    );
  }

  /**
   * [R] Get restaurant Items
   * @returns {Observable<Array<any>>}
   */
  public restaurantPromotionItems(): Observable<Array<any>> {
    return this.http.get(API('restaurant/promotion-items')).pipe(
      map((res: IResponse<any>) => {
        if (res.data) {
          return res.data.items;
        }
      })
    );
  }

  /**
   * Get all promo code for suppliers
   * @returns {Observable<any>}
   * @param query name
   * @param page
   * @param limit
   */
  public getRestaurantPromoCodes(query: string, page: string, limit: string, branch: string = null): Observable<any> {
    let params = new HttpParams();
    params = params.set('keyword', query);
    params = params.set('page', page);
    params = params.set('limit', limit);
    if (branch) {
      params = params.set('supplierId', branch);
    }
    return this.http.get(API('restaurant/promo'), {params});
  }


  public getPromoRedemmByID(query: string, page: string, limit: string, id: string = null): Observable<any> {
    let params = new HttpParams();
    params = params.set('keyword', query);
    params = params.set('page', page);
    params = params.set('limit', limit);
    if (id) {
      params = params.set('id', id);
    }
    return this.http.get(API('restaurant/promo/redem'), {params});
  }

  /**
   * Remove one promo code
   * @returns {Observable<any>}
   * @param promoId
   */
  public deletePromoCode(promoId: string): Observable<any> {
    return this.http.delete(API('promo/delete/' + promoId));
  }

  /**
   * Add vendor promo code
   * @returns {Observable<any>}
   * @param promoCode PromoCode
   */
  public saveRestaurantPromoCode(promoCode: PromoCode): Observable<any> {
    return this.http.post(API('promo'), {item: promoCode});
  }

  public getRestaurantPromoCode(id: string): Observable<any> {
    return this.http.get(API('promo/' + id));
  }

  public getSupplier(supplierId) {
    return this.http.get(API('restaurant/info/' + supplierId));
  }

  /**
   * Submit new SmartBite vendor.
   * @param data
   * @returns {Promise<any>}
   */
  public submitVendorInterest(data) {
    return this.http.post(environment.apiUrlClient + '/suppliers', data);
  }

  getSettings(): Promise<any> {
    return this.http.get(API('settings')).toPromise();
  }

  /**
   * Get supplier by token
   * @param token
   */
  getSupplierByToken(token): Observable<any> {
    return this.http.post(API('supplier-token-check'), {token});
  }

  /**
   * [R] Set acknowledged for order
   * @returns {Observable<Array<any>>}
   * @param orderId
   * @param acknowledged
   */
  public setOrderAcknowledged(orderId: string, acknowledged = false): Observable<any> {
    return this.http.post(API('restaurant/set-acknowledged'), {orderId, acknowledged});
  }

  /**
   * [R] Cancel order and Set acknowledged for order
   * @returns {Observable<Array<any>>}
   * @param _id
   */
  public cancelOrder(_id: string): Observable<any> {
    return this.http.patch(API('order/cancel-order'), {
      _id,
      reason: 'Order Cancelled by Vendor'
    });
  }

  /**
   * Attach a proof-of-pickup / proof-of-delivery photo to an order.
   * `file` is base64 with the data: prefix stripped. Same endpoint the Ops
   * board posts to, so both capture points store proof identically.
   */
  public uploadOrderProof(_id: string, type: 'pickup' | 'delivery', file: string, note?: string): Observable<any> {
    return this.http.post(API(`order/${_id}/proof`), {type, file, ...(note ? {note} : {})});
  }

  /**
   * Signed URLs for the stored proof photos. The order holds S3 keys, so links
   * are minted per request and expire in 15 minutes — fetch on load, never cache.
   */
  public getOrderProof(_id: string): Observable<any> {
    return this.http.get(API(`order/${_id}/proof`));
  }

  /**
   * [R] Update order Status
   * @returns {Observable<Array<any>>}
   * @param _id
   * @param status
   */
  public updateOrderStatus(_id: string, status: string, redeemQRCode: string ='', whoDeliver?: number, channel?: string): Observable<any> {
    const url = channel ? `order/${_id}/change-status?channel=${channel}` : `order/${_id}/change-status`;
    return this.http.patch(API(url), {
      _id,
      status,
      redeemQRCode,
      whoDeliver,
      serviceProvider:whoDeliver==1?'vendor':undefined
    });
  }

  // CSV Order Export
  exportCSVChildOrders(parentId: string ): Promise<any> {
    return new Promise((resolve, reject) => {
      let params = new HttpParams();
      return this.http.get(API('order/export-childorder-csv' + (parentId ? '/' + parentId : ''))
        , {params}).subscribe(
        response => resolve(response),
        error => reject(error));
    });
  }

  /**
   * [R] Update order payment Status
   * @returns {Observable<Array<any>>}
   * @param _id
   * @param paymentStatus
   */
  public updateOrderPaymentStatus(_id: string, paymentStatus: string): Observable<any> {
    return this.http.patch(API(`order/${_id}/change-payment-status`), {
      _id,
      paymentStatus
    });
  }

  /**
   * [R] Saves a new supplier
   * @param supplier supplier details
   */
  public saveSupplier(supplier: Supplier): Observable<any> {
    return this.http.post(API('/vendor/signup'), supplier);
  }

  /**
   * set public menu
   * @param itemId
   * @param active
   */
  setPublicMenu(itemId: string, active = false): Observable<any> {
    return this.http.patch(API('restaurant/change-public-menu/' + itemId), {active});
  }

  postDeliveryEstimate(_id: string, vehicleTypeId: string) {
    return this.http.post(API(`restaurant/${_id}/estimate`), {
      vehicleId: vehicleTypeId
    });
  }

  postPlaceDeliveryOrder(_id: string, vehicleTypeId: string, options = {}, bookingType: string = 'on-demand') {
    return this.http.post(API(`restaurant/${_id}/delivery-order`), {
      vehicleId: vehicleTypeId,
      bookingType,
      options
    });
  }

  deleteCancelDelivery(deliveryOrderId: string, id: string) {
    const params = new HttpParams().set('deliveryOrderId', id);
    return this.http.delete(API(`restaurant/${id}/delivery-order`), {params});
  }

  eodSettlements(date: Date, channels: any, status: string = 'accepted') {
    return this.http.post(API(`restaurant/eod-settlement`), {
      date, channels, status
    });
  }

  getEodSettlements(date) {
    return this.http.get(API('restaurant/eod-settlement/' + date));
  }

  eodDownload(channels: any[], date): Observable<any> {
    return this.http.post(API('restaurant/eod-download/'), {
      channels: channels,
      date: date
    });
  }

  /**
   * [R] Saves a new customer
   * @param customer Customer details
   */
  public createNewCustomer(customer: Customer): Observable<any> {
    return this.http.post(API('customer'), customer);
  }

  /**
   *
   * @param filter
   * @param sort
   * @param offset
   * @param limit
   */
  getCustomerByKeyword(filter: string, sort = 'name', offset?: number, limit?: number): Observable<any> {
    let params = new HttpParams().set('filter', filter).set('sort', sort);
    if (offset) {
      params = params.set('offset', offset.toString());
    }
    if (limit) {
      params = params.set('limit', limit.toString());
    }
    return this.http.get(API('vendor/customers'), {params});
  }

  /**
   * [R] Update a customer
   * @param customer Customer details
   */
  public updateCustomer(customer: Customer): Observable<any> {
    return this.http.patch(API('customer/' + customer._id), customer);
  }

  /**
   * Retrieve all T&C
   */
  getTerms(): Observable<any> {
    return this.http.get(API('terms'));
  }

  acceptVendorTerms(_id: string, termsAccepted: boolean): Observable<any> {
    return this.http.patch(API('supplier/vendor-account/' + _id), {
      termsAccepted
    });
  }

  updateProfile(body: any): Observable<any> {
    return this.http.post(API('vendor-account'),
      body
    );
  }

  /**
   * [R] Saves a new customer
   * @param customer Customer[] details
   */
  public uploadCustomers(customer: Customer[]): Observable<any> {
    return this.http.post(API('customer-upload'), customer);
  }

  /**
   * [R] Send payment link to customer
   * @param id
   */
  public sendOrderPaymentLink(id: String): Observable<any> {
    return this.http.post(API('restaurant/order/payment-link'), {id});
  }

  /**
   * [R] Send payment link to customer
   * @param supplierId
   * @param offset
   * @param limit
   * @param branch
   */
  public getSupplierReports(supplierId: string, offset: number, limit: number, branch: string = null): Observable<any> {
    let params = new HttpParams();
    if (branch) {
      params = params.set('filterSupplierId', branch);
    }
    return this.http.get(API(`supplier/${supplierId}/report?offset=${offset}&limit=${limit}`), {params});
  }

  downloadReport(supplierId: string, reportId: string, type: 'document' | 'report') {
    return this.http.get(API(`supplier/${supplierId}/${type}/${reportId}`));
  }

 /**
   * @param branch
   * @param fromDate
   * @param toDate
   */
 getTopRatedItems(branch: string = null, fromDate: any, toDate: any) {
   let params = new HttpParams();
   if (branch) {
     params = params.set('branch', branch);
   }
   if (fromDate) {
     params = params.set('fromDate', fromDate);
   }

   if (toDate) {
     params = params.set('toDate', toDate);
   }
   return this.http.get(API('supplier/top-rated-items'), {params});
 }
 /**
   * @param branch
   * @param fromDate
   * @param toDate
   */
  getMostRatedItems(branch: string = null, fromDate: any, toDate: any) {
    let params = new HttpParams();
    if (branch) {
      params = params.set('branch', branch);
    }
   if (fromDate) {
     params = params.set('fromDate', fromDate);
   }

   if (toDate) {
     params = params.set('toDate', toDate);
   }
    return this.http.get(API('supplier/most-rated-items'), {params});
  }
 /**
   * @param branch
   */
  getWorstRatedItems(branch: string = null, fromDate: any, toDate: any) {
    let params = new HttpParams();
    if (branch) {
      params = params.set('branch', branch);
    }
   if (fromDate) {
     params = params.set('fromDate', fromDate);
   }

   if (toDate) {
     params = params.set('toDate', toDate);
   }
    return this.http.get(API('supplier/worst-rated-items'), {params});
  }
 /**
   * @param branch
   */
  getTopSellingItems(branch: string = null) {
    let params = new HttpParams();
    if (branch) {
      params = params.set('branch', branch);
    }
    return this.http.get(API('supplier/top-selling-items'), {params});
  }

  /**
   * [R] Send promo code to customer emails
   * @param request promo code details
   */
  public sendPromoCodeEmail(request: any): Observable<any> {
    return this.http.post(API('restaurant/email/promo'), request);
  }

  /**
   * [R] Save setting for supplier
   * @param request promo code details
   * @param supplierId
   */
  public saveSettings(request: any, supplierId): Observable<any> {
    return this.http.put(API(`vendor/${supplierId}/edit-settings`), request);
  }

  public replyToCustomerFeedback(to: string, customerName: string, commentId: string, comment: string): Observable<any> {
    return this.http.post(API('restaurant/reply-comment'), {commentId, to, customerName, comment});
  }

  addReviewResponse(supplierId: string, orderId: string, reviewId:string, comment: string,responseId :string,isUpdate :boolean,isVendor=true, isSmartCanteen=false): Observable<any> {
    return this.http.post(API(`supplier/review/${supplierId}/${orderId}`), {comment,reviewId,responseId,isUpdate,isVendor,isSmartCanteen});
  }
  /**
   * [R] Update CustomFoodItem
   * @param supplierId
   * @param type
   * @param item
   */
  public patchCustomFoodItem(supplierId: string, type: 'chain' | 'supplier', item: any): Observable<any> {
    let param = '';
    if (item._id) {
      param = '/' + item._id;
    }
    return this.http.post(API(`restaurant/${type}/${supplierId}/food-custom-item${param}`), item);
  }

  /**
   * [R] Update FoodItem
   * @param supplierId
   * @param type
   * @param item
   */
  public patchFoodItem(supplierId: string, type: 'chain' | 'supplier', item: FoodItem): Observable<any> {
    let param = '';
    if (item._id) {
      param = '/' + item._id;
    }
    return this.http.post(API(`restaurant/${type}/${supplierId}/food-item${param}`), item);
  }

  /**
   * [R] Update Supplier
   * @param supplierId
   * @param type
   * @param data
   */
  public patchVendor(supplierId: string, type: 'chain' | 'supplier', data: any): Observable<any> {
    if(type==='chain'){
      data.page= 'settings';
      return this.http.patch(API(`chain/${supplierId}`), data);
    }else{
      return this.http.patch(API(`restaurant/${type}/${supplierId}`), data);
    }
  }

  /**
   * [R] Send quotation to customer emails
   * @param orderId
   * @param email,
   */
  public sendQuotationEmailToCustomer(orderId: string, email: {
    to: string, cc: string, subject: string, message: string
  }): Observable<any> {
    return this.http.post(API(`/restaurant/${orderId}/send-quote`), email);
  }
  // Refund Hook
  public sendRefund(orderId: string, data: {
    refundCategory : string,
    refundAmount: number,
    refundType: string,
    refundPercentage: string,
    refundPercentageCustom: number,
    refundReason: string,
    receipt:boolean
  }): Observable<any> {
    return this.http.post(API(`restaurant/${orderId}/send-refund`), data);
  }

  sendFeedback(data: any, type: any): Observable<any> {
    let headers = new HttpHeaders();
    if (type) {
      headers = headers.set('type', type);
    }
    return this.http.post(API('restaurant/feedback'), data, {headers});
  }

  /**
   * @param range
   * @param branch
   */
  getOrderDetailsForGraph(range: any, branch: string = null, fromDate: any, toDate: any): Observable<any> {
    let params = new HttpParams().set('range', range);
    if (branch) {
      params = params.set('supplierId', branch);
    }
    if (fromDate) {
      params = params.set('fromDate', fromDate);
    }

    if (toDate) {
      params = params.set('toDate', toDate);
    }
    return this.http.get(API('restaurant/chart/orders'), {params});
  }

  /**
   * @param range
   * @param type
   * @param branch
   */
  getOrderDetailsForMap(range: any, type: string, branch: string = null, fromDate: any, toDate: any): Observable<any> {
    let params = new HttpParams().set('range', range);
    if (branch) {
      params = params.set('supplierId', branch);
    }
    if (fromDate) {
      params = params.set('fromDate', fromDate);
    }

    if (toDate) {
      params = params.set('toDate', toDate);
    }
    return this.http.get(API('restaurant/map/orders'), {params});
  }

  /**
   * [R] Create Inquiries
   * @param data
   * @param type
   */
  public createInquiries(data: Inquiries, type = 'catering'): Observable<any> {
    return this.http.post(API('inquiries/add'), {...data, type});
  }

  /**
   * [R] Create Quotation
   * @param data
   */
  public createQuotation(data: Quotation): Observable<any> {
    return this.http.post(API('quotation'), data);
  }

  public getQuotation(quotationId: string) {
    return this.http.get(API('quotation/' + quotationId));
  }

  public getAllQuotations(query: string, offset: number, limit: number) {
    const params = new HttpParams().set('offset', offset.toString()).set('limit', limit.toString()).set('query', query);
    return this.http.get(API('quotations'), {params});
  }

  public deleteQuotation(quotationId: string) {
    return this.http.delete(API(`quotation/${quotationId}`));
  }

  /**
   * [R] Create Quotation
   * @param data
   */
  public createProposedMenu(data: ProposedMenu): Observable<any> {
    return this.http.post(API('proposed-menu'), data);
  }

  public getProposedMenu(proposedMenuId: string) {
    return this.http.get(API('proposed-menu/' + proposedMenuId));
  }

  public deleteProposedMenu(proposedMenuId: string) {
    return this.http.delete(API(`proposed-menu/${proposedMenuId}`));
  }

  public getAllProposedMenus(query: string, offset: number, limit: number) {
    const params = new HttpParams().set('offset', offset.toString()).set('limit', limit.toString()).set('query', query);
    return this.http.get(API('proposed-menus'), {params});
  }

  public getSupplierStores(externalId: string) {
    return this.http.get(API('restaurant/stores/' + externalId));
  }

  /**
   * Get all roles
   * @returns {Observable<any>}
   * @param offset
   * @param limit
   * @param id
   */
  public getRoles(offset: string, limit: string, id: string = null): Observable<any> {
    let params = new HttpParams();
    params = params.set('offset', offset);
    params = params.set('limit', limit);
    if (id) {
      params = params.set('id', id);
    }
    return this.http.get(API('restaurant/roles'), {params});
  }

  /**
   * Get all Permission
   * @returns {Observable<any>}
   */
  public getAllPermission(): Observable<any> {
    return this.http.get(API('vendor/permissions'));
  }

  /**
   * [R] Create Edit Roles
   * @param data
   */
  public createEditRole(data: Role): Observable<any> {
    return this.http.post(API('restaurant/roles'), data);
  }

  /**
   * delete roles
   * @returns {Observable<any>}
   * @param id
   */
  public deleteRoles(id: string): Observable<any> {
    return this.http.delete(API(`restaurant/roles/${id}`));
  }

  /**
   * Get all users
   * @returns {Observable<any>}
   * @param offset
   * @param limit
   * @param type
   * @param id
   * @param accountId
   */
  public getUsers(offset: string, limit: string, type: 'chain' | 'vendor', id: string, accountId: string = null): Observable<any> {
    let params = new HttpParams();
    params = params.set('offset', offset);
    params = params.set('limit', limit);
    if (accountId) {
      params = params.set('accountId', accountId);
    }

    return this.http.get(API(`restaurant/${type}-users/${id}`), {params});
  }

  /**
   * [R] Edit User
   * @param user
   * @param id
   * @param type
   */
  public createEditUser(user: User, id: string, type: 'chain' | 'vendor'): Observable<any> {
    return this.http.post(API(`restaurant/${type}-users/${id}`), user);
  }

  /**
   * delete roles
   * @returns {Observable<any>}
   * @param id
   */
  public deleteUser(id: string): Observable<any> {
    return this.http.delete(API(`vendor-account/${id}`));
  }

  public sendRainingEmailToCustomer(date?: string) {
    return this.http.get(API('restaurant/delay-email/' + date));
  }

  public pushNotificationSubscription() {
    this.swPush.requestSubscription({
      serverPublicKey: 'BJT-ksXNnjbdZ-PK3tB2lY7HGJE9SRvcP7SVtCq309O5hvhrNuOd_4dvCWx-8_pKbeFpvr5teabz6p2FudxeoFY'
    })
      .then(sub => {
        this.http.post(API('restaurant/push-notification-subscription'), {sub}).subscribe(
          () => {
          },
          (error) => console.log(error)
        );
      })
      .catch(err => console.error('Could not subscribe to notifications', err));
  }

  getOtp(supplierId: string, fromDate: any, toDate: any): Observable<any> {
    let params = new HttpParams();
    if(fromDate){
      params = params.set('fromDate', fromDate);
    }

    if(toDate){
      params = params.set('toDate', toDate);
    }
    return this.http.get(API(`supplier/otp/${supplierId}`), {params});
  }

  getOtpToday(supplierId: string): Observable<any> {
    return this.http.get(API(`supplier/otp-today/${supplierId}`));
  }

  /**
   * Incremeant the reveal of phone number
   * @returns {Observable<any>}
   * @param orderId
   */
  countRevealPhoneNumber(orderId: string): Observable<any> {
    return this.http.get(API('restaurant/count-reveal-phone-number/' + orderId));
  }

  /**
   * Download Smart Canteen Child Order label
   * @returns {Observable<any>}
   * @param orderId: string
   */
  downloadSmartCanteenChildOrder(orderId: string, size: string = 'A4') {
    let params = new HttpParams().set('size', size);
    return this.http.get(API(`restaurant/${orderId}/download-smartcanteen-labels`), {params});
  }

  /**
   * Generate Ninjavan Way bill
   * @returns {Observable<any>}
   * @param orderId: string
   */
  generateNinjaVanWayBill(orderId: string) {
    return this.http.get(API(`restaurant/${orderId}/generate-ninja-waybill`));
  }

  /**
   * Cancelled Order API Endpoint
   * @returns {Observable<any>}
   * @param orderId: string
   * @param reason: string
   */
  cancelledOrder(orderId: string, reason: string) {
    return this.http.patch(API(`order/cancel-order`), {_id: orderId, reason});
  }
}
